<mat-toolbar fxLayout="row" fxLayoutAlign="space-between center" color="primary">
    <span>
        {{ title || 'Excel Import' }}
    </span>
    <button [attr.guide]="'import-excel-btn-1' + '__' + sanitizedUrl" mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
    </button>
</mat-toolbar>

<div class="products-padding" *ngIf="!uploadedFile; else elseBlock">
    <div fxLayout="column" fxLayoutGap="12px">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
            <input #fileInput [attr.guide]="'import-excel-inp-2' + '__' + sanitizedUrl" [autocomplete]="'off'" type="file" accept=".xlsx,.xls,.csv" ng2FileSelect [uploader]="uploader"/>
        </div>

        <div *ngIf="uploader?.queue?.length > 0" class="file-name-info">
            <mat-icon class="file-icon" color="primary">description</mat-icon>
            <span>Selected File: <strong>{{ uploader.queue[0]?.file?.name }}</strong></span>
        </div>

        <!-- Validation Errors Display -->
        <div *ngIf="validationErrors && validationErrors.length > 0" class="validation-error-container">
            <div class="validation-error-header" fxLayout="row" fxLayoutAlign="space-between center">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="6px">
                    <mat-icon color="warn">error_outline</mat-icon>
                    <span class="error-title">Validation Failed ({{ validationErrors.length }} invalid record{{ validationErrors.length > 1 ? 's' : '' }} found)</span>
                </div>
                <button type="button" mat-button color="warn" class="clear-btn" (click)="clearValidationErrors()">
                    <mat-icon>clear</mat-icon> Clear
                </button>
            </div>
            <div class="error-subtitle">
                The uploaded file contains missing or invalid fields. Please correct the affected row(s) and field(s) before importing:
            </div>
            <div class="table-scroll-wrapper">
                <table class="validation-table" fxFlex>
                    <thead>
                        <tr>
                            <th style="width: 80px;">Row</th>
                            <th style="width: 140px;">Field</th>
                            <th>Validation Message</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let err of validationErrors">
                            <td class="row-cell"><span class="row-badge">{{ err.row }}</span></td>
                            <td class="field-cell"><strong>{{ err.field }}</strong></td>
                            <td class="msg-cell">{{ err.message }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <mat-dialog-actions align="center" style="margin-top: 15px;">
        <div class="products-padding" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">
            <button [attr.guide]="'import-excel-btn-3' + '__' + sanitizedUrl" #dummyID mat-raised-button color="primary" *ngIf="uploader?.queue?.length > 0" [disabled]="text != 'Upload' || (validationErrors && validationErrors.length > 0)" (click)="upload()">
              {{ text }}
              <mat-icon *ngIf="text != 'Upload'">
                <mat-spinner color="accent" diameter="20"></mat-spinner>
              </mat-icon>
            </button>
            <button type="button" mat-button (click)="close()">Cancel</button>
        </div>
    </mat-dialog-actions>
</div>

<ng-template #elseBlock>
  <div class="products-padding" fxLayout="column" *ngIf="faliedList.length > 0">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px" style="margin-bottom: 10px;">
        <mat-icon color="warn">warning</mat-icon>
        <strong style="color: #c53030; font-size: 15px;">Import Rejected / Failed Records ({{ faliedList.length }} record{{ faliedList.length > 1 ? 's' : '' }}):</strong>
    </div>
    <div class="table-scroll-wrapper">
        <table class="validation-table" fxFlex>
            <thead>
                <tr>
                    <th style="width: 80px;" *ngIf="hasRowProperty(faliedList)">Row</th>
                    <th style="width: 150px;">Field / Identifier</th>
                    <th>Error Details</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of faliedList">
                    <td class="row-cell" *ngIf="hasRowProperty(faliedList)"><span class="row-badge">{{ item.row || item.rowNumber || '-' }}</span></td>
                    <td class="field-cell"><strong>{{ item.field || item.name || item.referenceNo || 'Item' }}</strong></td>
                    <td class="msg-cell">{{ item.importError || item.message || item.error || 'Validation error' }}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <mat-dialog-actions align="center" style="margin-top: 15px;">
        <button mat-raised-button color="primary" (click)="close()">Close</button>
    </mat-dialog-actions>
  </div>
</ng-template>
